import axios from 'axios';

const client = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api',
});

let orderingToken: string | null = null;
const TOKEN_KEY = 'orderingToken';
try { const t = localStorage.getItem(TOKEN_KEY); if (t) orderingToken = t; } catch (_) {}

export function setOrderingToken(token: string) {
  orderingToken = token;
  try { localStorage.setItem(TOKEN_KEY, token); } catch (_) {}
}

export function clearOrderingToken() {
  orderingToken = null;
  try {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem('orderingSession');
  } catch (_) {}
}

client.interceptors.request.use((config) => {
  if (orderingToken) {
    config.headers = config.headers || {};
    (config.headers as any).Authorization = `Bearer ${orderingToken}`;
  }
  return config;
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    try {
      const status = error?.response?.status;
      if (status === 401 || status === 403) {
        clearOrderingToken();
        try {
          window.dispatchEvent(new Event('ordering:logout'));
        } catch (_) {}
      }
    } catch (_) {}
    return Promise.reject(error);
  }
);

export default client;






